// extracted by mini-css-extract-plugin
module.exports = {"blog_title":"BlogDetails_blog_title__1nB9W"};